import { useState } from 'react'
import DateRangeChipModal from '../modals/DateRangeChipModal'

function fmt(iso) {
  if (!iso) return ''
  const [y, m, d] = iso.split('-')
  return `${d}/${m}/${y.slice(2)}`
}

/**
 * Chip azul de date range. Click abre modal. Hover muestra X para remover.
 * @param {Object} filters - { created_from, created_to }
 * @param {Function} updateFilter - (key, value) => void
 * @param {boolean} autoOpen - abrir el modal al montar (filtro recien agregado)
 * @param {Function} onRemove - () => void (quita el chip y limpia su valor)
 */
export default function DateRangeChip({ filters, updateFilter, autoOpen = false, onRemove }) {
  const [open, setOpen] = useState(!!autoOpen)
  const { created_from, created_to } = filters

  const handleRemove = (e) => {
    e.stopPropagation()
    if (onRemove) onRemove()
  }

  const handleConfirm = (from, to) => {
    updateFilter('created_from', from)
    updateFilter('created_to', to)
  }

  const label = created_from && created_to
    ? `📅 ${fmt(created_from)} → ${fmt(created_to)}`
    : created_from ? `📅 desde ${fmt(created_from)}`
    : created_to ? `📅 hasta ${fmt(created_to)}`
    : '📅 Fecha (elegir)'

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        type="button"
        className="group flex items-center gap-1 px-3 py-1 text-xs font-medium rounded-full bg-blue-100 dark:bg-blue-900/40 text-blue-800 dark:text-blue-200 hover:bg-blue-200 dark:hover:bg-blue-900/60 transition-colors"
      >
        <span>{label}</span>
        <span
          onClick={handleRemove}
          className="opacity-0 group-hover:opacity-100 transition-opacity ml-1 cursor-pointer"
          role="button"
        >
          ✕
        </span>
      </button>
      {open && (
        <DateRangeChipModal
          initialFrom={created_from}
          initialTo={created_to}
          onConfirm={handleConfirm}
          onClose={() => setOpen(false)}
        />
      )}
    </>
  )
}
